(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-marquee"] && !Shopify.designMode) return;
  try {
    
const googleVisible = 3;
const googleCardWidth = 360;

const innerGoogle = document.getElementById("googleInner");
const leftGoogle = document.getElementById("googleLeft");
const rightGoogle = document.getElementById("googleRight");

let googlePage = 0;
const googleTotal = innerGoogle.children.length;
const googleMaxPage = Math.ceil(googleTotal / googleVisible) - 1;

rightGoogle.addEventListener("click", () => {
  if (googlePage < googleMaxPage) googlePage++;
  innerGoogle.style.transform =
    `translateX(-${googlePage * googleVisible * googleCardWidth}px)`;
});

leftGoogle.addEventListener("click", () => {
  if (googlePage > 0) googlePage--;
  innerGoogle.style.transform =
    `translateX(-${googlePage * googleVisible * googleCardWidth}px)`;
});

  } catch(e) { console.error(e); }
})();
})();
